import React, { Fragment, useEffect, useState } from "react";
import LoanSwitchBox from "./LoanSwitchBox";
import { Button, Col, Form, Modal, Popover, Row, Select } from "antd";
import { useLocation, useNavigate } from "react-router-dom";
import { Radio } from "antd";
import {
  CheckCircleOutlined,
  InfoCircleOutlined,
  DownloadOutlined,
  EditOutlined,
  PercentageOutlined,
  SyncOutlined,
} from "@ant-design/icons";
import { Input } from "antd";
import { Field, Formik, ErrorMessage } from "formik";
import GuarantorSwitchBox from "./GuarantorSwitchBox";
import { FurnishOptions, IMAGE_BASE_URL } from "../../common/Constants";
import { objToArray } from "../../common/Utilities";
import AAUpload from "../../components/AAUpload";
import { ServerAPI } from "../../common/ServerAPI";
import { toast } from "react-toastify";
import { InputNumber } from "antd";
import GuarantorDocumentView from "../../components/GuarantorDocumentView";

const ApplicationCaseStatus = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [selectedGuarantors, setSelectedGuarantors] = useState([]);
  const [selectedGuarantor, setSelectedGuarantor] = useState(0);
  const [counterOfferValues, setCounterOfferValues] = useState({});
  const [isMonthlyInstallmentEdited, setIsMonthlyInstallmentEdited] = useState(false);

  const [disabled, setdisabled] = useState({
    interest: true,
    loan_amt: true,
    tenure: true,
    dealer_commission: true,
    admin_fee: true,
    last_installment: true,
    monthly_installment: true,
  });
  const loanData = location.state.loanData;
  const updatedData = loanData?.counterData;
  const title = location.state.title;
  const icon = location.state.icon;
  const { TextArea } = Input;
  const [actionType, setActionType] = useState("");
  const [guarantoraction, setGuarantorAction] = useState("");
  const [rejectionReason, setRejectionReason] = useState("");
  const [reasonforAdvise, setReasonforAdvise] = useState("");
  const [rejectReason, setRejectReason] = useState("");
  const [guarantorDocuments, setGuarantorDocuments] = useState([]);
  const [statusData, setStatusData] = useState({});
  const [selfAA, setSelfAA] = useState([]);
  const [furnishGuarantorCounts, setFurnishGuarantorCounts] = useState(0);
  const [furnishGuarantorDatas, setFurnishGuarantorDatas] = useState([]);
  const [documentView, setDocumentView] = useState(false);
  const [documentUrl, setDocumentUrl] = useState([]);

  let TabObj = [];
  TabObj.push({
    name: "Furnish Guarantor",
    dataIndex: TabObj.length + 1,
    furnish: true,
  });

  const buildPreviewData = (baseData, counterValues) => {
    return {
      ...baseData,
      preview_counter_values: counterValues,
    };
  };

  const UpdateStatus = async (saveType) => {
    let data = {};
    let instant = 0;
    if (loanData?.type == "In-House") {
      if (actionType == "approve_instant" || actionType == "counter_instant") {
        instant = 1;
      }
    } else {
      if (actionType == "approve_instant_bank") {
        instant = 1;
      } else {
        instant = 0;
      }
    }

    data["loan_application"] = localStorage.getItem("applicationId");
    data["application_product"] = loanData.application_product;
    data["product"] = loanData.product_id;
    data["interest"] = loanData.interest_id;
    data["agentcommision"] = loanData.agentcommision;
    data["description"] =
      actionType == "reject" ? rejectReason : reasonforAdvise;
    data["is_counter_offered"] =
      actionType == "counter_instant" || actionType == "counter_later" ? 1 : 0;
    data["is_rejected"] = actionType == "reject" ? 1 : 0;
    data["is_approved"] =
      actionType == "approve_instant" ||
        actionType == "approve_later" ||
        actionType == "approve_instant_bank"
        ? 1
        : 0;
    // data["is_approved"] = 1
    data["instant_aa"] = instant;
    data["aa_files"] = selfAA;
    {
      selectedGuarantors != undefined &&
        selectedGuarantors.length > 0 &&
        selectedGuarantors.map((guarantor, idx) => {
          data["guarantor_" + idx + 1] = guarantor;
        });
    }
    if (actionType == "counter_instant" || actionType == "counter_later") {

      let counterValue = {
        tenure: counterOfferValues.tenure,
        parfvalue: loanData.parf,
        loanamount: counterOfferValues.loanamount,
        interest: counterOfferValues.interest,
        agentcommsion: counterOfferValues.dealer_commission_percentage,
        admin_fee: counterOfferValues.admin_fee,
        last_installment: counterOfferValues.last_installment,
        remarks: counterOfferValues.remarks,
        terms_and_conditions: counterOfferValues.terms_and_conditions,
        monthly_installment: counterOfferValues.monthly_installment
      };
      // Only include monthly_installment if user edited it
      if (isMonthlyInstallmentEdited) {
        counterValue.monthly_installment = counterOfferValues.monthly_installment;
      }
      data["counter_value"] = counterValue;

      if (
        furnishGuarantorDatas != undefined &&
        furnishGuarantorDatas.length > 0
      ) {
        data["furnish_guarantors"] = furnishGuarantorDatas;
      }
    }

    if (saveType == "save") {
      // navigate("/preview-aa", { state: data });
      const previewData = buildPreviewData(data, counterOfferValues);
      navigate("/preview-aa", { state: previewData });
    } else if (saveType == "confirmstay") {
      const response = await ServerAPI.updateProductStatus(data);
      if (response) {
        toast.success(response.message);
      }
    } else {
      const response = await ServerAPI.updateProductStatus(data);
      if (response) {
        toast.success(response.message);
        navigate(-1);
      }
    }
  };

  const onChange = (value) => {
    setFurnishGuarantorCounts(value);
  };

  const handleDropdownChange = (name, value, index) => {
    let furnishGuarantors = [...furnishGuarantorDatas];
    furnishGuarantors[index][name] = value;
  };

  const renderRows = () => {
    const rows = [];
    let rowsData = [];

    for (let i = 0; i < furnishGuarantorCounts; i++) {
      rows.push(
        <div key={i}>
          <p className="text-[13px] font-[700] mb-2">
            Additional Guarantor ({i + 1})
          </p>
          <Row gutter={[16, 16]} className="mb-3">
            <Col xs={24} sm={12} md={8} lg={8}>
              <label className="mb-2 text-[13px] text-[#495159] w-full">
                Guarantor Relation
                <br />
                <Select
                  style={{
                    width: "100%",
                  }}
                  onChange={(e) => {
                    handleDropdownChange("guarantor_relation", e, i);
                  }}
                  options={FurnishOptions}
                />
              </label>
            </Col>
            <Col xs={24} sm={12} md={8} lg={8}>
              <label className="mb-2 text-[13px] text-[#495159] w-full">
                Guarantor Min. Income (mths)
                <Input
                  onChange={(e) => {
                    handleDropdownChange("guarantor_income", e.target.value, i);
                  }}
                  placeholder="Min Income"
                />
              </label>
            </Col>
          </Row>
        </div>
      );
    }
    return rows;
  };

  const Table = () => {
    return (
      <div className="">
        <div className="flex items-center justify-between px-3 py-2 bg-[#d9e7fe] rounded-tl-lg rounded-tr-lg">
          <div className="flex w-4/4">
            <div className="img-container-loan ml-[-10px] mt-[5px]">
              <img className="loan-img" src={IMAGE_BASE_URL + icon} />
            </div>
            <p className="min-[768px]:mt-3 text-[16px] font-[700]">{title}</p>
          </div>
        </div>
      </div>
    );
  };

  const handleChange = (e, formikProps) => {
    const { name, value } = e.target;
    let data = { ...counterOfferValues };
    const numValue = parseFloat(value) || 0;
    if (["loanamount", "tenure", "interest", "admin_fee", "dealer_commission_percentage"].includes(name)) {
      data[name] = numValue;
    }
    if (["loanamount", "tenure", "interest"].includes(name)) {
      const interestRate = parseFloat(formikProps.values.interest || 0);
      const loanAmount = parseFloat(formikProps.values.loanamount || 0);
      const tenure = parseInt(formikProps.values.tenure || 0);

      if (loanAmount && tenure && interestRate) {
        const totalInterest = loanAmount * (interestRate / 100) * (tenure / 12);
        const repayment = loanAmount + totalInterest;
        const monthlyInstallment = Math.floor(repayment / tenure);
        const prorateRounding = monthlyInstallment * (tenure - 1);
        const lastInstallment = repayment - prorateRounding;

        data.monthly_installment = monthlyInstallment;
        data.last_installment = lastInstallment;
      }
    }
    setCounterOfferValues(data);
  };

  const Inhouseoptions = [
    { label: "Approve & Issue AA Instantly", value: "approve_instant" },
    { label: "Approve But Issue AA Later", value: "approve_later" },
    { label: "Counter Offer & Issue AA Instantly", value: "counter_instant" },
    { label: "Counter Offer But Issue AA Later", value: "counter_later" },
    { label: "Reject Loan Application", value: "reject" },
  ];

  const options = [
    { label: "Approve & Upload AA", value: "approve_instant_bank" },
    { label: "Submit Counter Offer", value: "counter_instant" },
    { label: "Reject  Loan Application", value: "reject" },
  ];

  const selectGuarantor = (id) => {
    let selectedIds = [...selectedGuarantors];
    let indexToRemove = selectedIds.indexOf(id);
    if (indexToRemove !== -1) {
      selectedIds.splice(indexToRemove, 1);
      setSelectedGuarantors(selectedIds);
    } else {
      selectedIds.push(id);
      setSelectedGuarantors(selectedIds);
    }
  };

  useEffect(() => {
    let dataDocuments = [];
    dataDocuments = objToArray(
      loanData["available_guarantors"]?.[selectedGuarantor]?.guarantor_docs
    );
    setGuarantorDocuments(dataDocuments);
  }, [selectedGuarantor]);

  useEffect(() => {
    let rowsData = [];
    for (let i = 0; i < furnishGuarantorCounts; i++) {
      rowsData.push({
        guarantor_relation: "",
        guarantor_income: "",
      });
    }
    setFurnishGuarantorDatas(rowsData);
  }, [furnishGuarantorCounts]);


  //Initial data 
  useEffect(() => {
    const getValue = (updatedValue, fallbackValue) =>
      updatedValue !== null && updatedValue !== undefined && updatedValue !== "" ? updatedValue : fallbackValue;
    if (!loanData) return;
    const monthlyInstallment = loanData.mnthly_installement
      ? parseFloat(loanData.mnthly_installement)
      : (parseFloat(loanData.interest) / 100 / 12) * parseInt(loanData.loan_amt) +
      parseInt(loanData.loan_amt) / parseInt(loanData.tenor);
    const totalInterest = parseInt(loanData.loan_amt) * (loanData.interest / 100) * (loanData.tenor / 12);
    const repayment = parseInt(loanData.loan_amt) + parseInt(totalInterest);
    const prorateRounding = monthlyInstallment * (loanData.tenor - 1);
    const calculatedLastInstallment = repayment - prorateRounding;
    const counterData = {
      parfvalue: loanData.parf,
      interest: getValue(updatedData?.interest, loanData.interest),
      loanamount: parseInt(getValue(updatedData?.loanamount, loanData.loan_amt)),
      tenure: getValue(updatedData?.tenure, loanData.tenor),
      dealer_commission_percentage: getValue(updatedData?.agentcommsion, loanData.dealer_commission_percentage),
      admin_fee: parseInt(getValue(updatedData?.admin_fee, loanData.admin_fee)),
      monthly_installment: getValue(updatedData?.monthly_installment, monthlyInstallment),
      last_installment: getValue(updatedData?.last_installment, loanData.last_installment ?? calculatedLastInstallment),
      remarks: getValue(updatedData?.remarks, loanData.remarks),
      terms_and_conditions: getValue(updatedData?.terms_and_conditions, loanData.terms_and_conditions),
    };
    setCounterOfferValues(counterData);
    if (location.state?.optLabel) {
      setActionType(location.state.optLabel);
    }
  }, [loanData, updatedData, location.state?.optLabel]);

  const isSavePreview = () => {
    if (loanData?.available_guarantors.length === 0) {
      return false;
    }
    if (selectedGuarantors.length == 0) {
      return true;
    } else {
      return false;
    }
  };

  return (
    <div className="w-full min-h-screen bg-[#F5F5F5] overflow-x-hidden">
      <div className="bg-white">
        <Row gutter={[24, 24]} className="p-[18px_25px]">
          <Col xs={24} sm={12} md={24} lg={24}>
            <div className="text-[18px] font-[700] bg-white flex">
              <div
                className="mt-1 min-[768px]: mr-5 max-[768px]:mr-1 cursor-pointer"
                onClick={() => navigate(-1)}
              >
                <img src="/images/left-circle.svg" alt="arrow" />
              </div>
              <p>Loan Application</p>
            </div>
          </Col>
        </Row>
      </div>
      <div
        className="app-detail-tab-content mx-5 mt-5 p-5"
        style={{ maxHeight: "100%" }}
      >
        <Table />
        <div className="">
          <table className="min-w-full">
            <thead>
              <tr className="px-5">
                <th className="whitespace-nowrap pr-4 pl-[0.75rem] py-4 bg-[#D9E7FE] text-center text-[13px]">
                  Loan Product Name
                </th>
                <th className="whitespace-nowrap px-4 py-4 bg-[#D9E7FE] text-center text-[13px]">
                  Interest
                </th>
                <th className="whitespace-nowrap px-4 py-4 bg-[#D9E7FE] text-center text-[13px]">
                  Loan Amt.
                </th>
                <th className="whitespace-nowrap px-4 py-4 bg-[#D9E7FE] text-center text-[13px]">
                  Tenor (mths)
                </th>
                <th className="whitespace-nowrap px-4 py-4 bg-[#D9E7FE] text-center text-[13px]">
                  Dealer Comm.
                </th>
                <th className="whitespace-nowrap px-4 py-4 bg-[#D9E7FE] text-center text-[13px]">
                  Admin Fee
                </th>
                <th className="whitespace-nowrap px-4 py-4 bg-[#D9E7FE] text-center text-[13px]">
                  Mthly. Installment
                </th>
                <th className="whitespace-nowrap px-4 py-4 bg-[#D9E7FE] text-center text-[13px]">
                  Last Installment
                </th>
              </tr>
            </thead>
            <tbody className="bg-white loan-status-update-tbody rounded-bl-lg rounded-br-lg">
              {loanData !== undefined && (
                <tr className="loan-tb-tr">
                  <td className="whitespace-nowrap px-3 py-4 text-left">
                    <div className="text-[#1B252F] text-[13px] font-[400]">
                      {"[ " + loanData?.scheme + " ] "}
                    </div>
                    <div className="text-[13px] font-[700]">{loanData.product_name}</div>
                    <div>
                      <p
                        onClick={() => {
                          navigate("/view-application", {
                            state: {
                              productId: loanData.application_product,
                            },
                          });
                        }}
                        className="cursor-pointer text-[#0660FC] text-[13px]"
                      >
                        View Application Form
                      </p>
                    </div>
                  </td>

                  <td
                    className={
                      loanData?.counterData != null
                        ? "whitespace-nowrap px-5 py-4 text-left text-[13px] font-[400] text-[#F80707]"
                        : "whitespace-nowrap px-5 py-4 text-left text-[13px] font-[400]"
                    }
                  >
                    {loanData.interest}%
                    {loanData?.counterData?.interest && (
                      <p className="text-[#00AE11] font-[600] mt-2">
                        {loanData?.counterData?.interest}%{" "}
                      </p>
                    )}
                  </td>

                  <td
                    className={
                      loanData?.counterData != null
                        ? "whitespace-nowrap px-5 py-4 text-left text-[13px] font-[400] text-[#F80707]"
                        : "whitespace-nowrap px-5 py-4 text-left text-[13px] font-[400]"
                    }
                  >
                    ${loanData.loan_amt}
                    {loanData?.counterData?.loanamount && (
                      <p className="text-[#00AE11] font-[600] mt-2">
                        ${parseInt(loanData?.counterData?.loanamount).toFixed(0)}
                      </p>
                    )}
                  </td>

                  <td
                    className={
                      loanData?.counterData != null
                        ? "whitespace-nowrap px-5 py-4 text-left text-[13px] font-[400] text-[#F80707]"
                        : "whitespace-nowrap px-5 py-4 text-left text-[13px] font-[400]"
                    }
                  >
                    {loanData.tenor}
                    <p className="text-[#00AE11] font-[600] mt-2">
                      {loanData?.counterData?.tenure}
                    </p>
                  </td>

                  <td className="whitespace-nowrap px-5 py-4 text-left text-[13px]">
                    <div
                      className={
                        loanData?.counterData
                          ? "whitespace-nowrap text-[13px] font-[400] text-[#F80707]"
                          : "whitespace-nowrap text-[13px] font-[400]"
                      }
                    >
                      {loanData?.dealer_commission_percentage === "0.00"
                        ? "0"
                        : parseFloat(loanData?.dealer_commission_percentage).toFixed(1)}
                      % (${
                        Math.round(Number(loanData?.dealer_commission_amount))
                      })

                      {loanData?.counterData?.agentcommsion && (
                        <p className="text-[#00AE11] font-[600] mt-2">
                          {parseFloat(loanData?.counterData?.agentcommsion).toFixed(1)}% (${
                            Math.round(
                              (loanData?.counterData?.agentcommsion * loanData?.counterData?.loanamount) / 100
                            )
                          })
                        </p>
                      )}
                    </div>
                  </td>

                  <td
                    className={
                      loanData?.counterData != null
                        ? "whitespace-nowrap px-5 py-4 text-left text-[13px] font-[400] text-[#F80707]"
                        : "whitespace-nowrap px-5 py-4 text-left text-[13px] font-[400]"
                    }
                  >
                    ${parseFloat(loanData.admin_fee).toFixed(0)}
                    {loanData?.counterData?.admin_fee && (
                      <p className="text-[#00AE11] font-[600] mt-2">
                        ${parseFloat(loanData?.counterData?.admin_fee).toFixed(0)}
                      </p>
                    )}
                  </td>

                  <td
                    className={
                      loanData?.counterData != null
                        ? "whitespace-nowrap px-5 py-4 text-left text-[13px] font-[400] text-[#F80707]"
                        : "whitespace-nowrap px-5 py-4 text-left text-[13px] font-[400]"
                    }
                  >
                    ${loanData.mnthly_installement != null ? Math.ceil(parseFloat(loanData.mnthly_installement)) : 'N/A'}
                    {loanData?.counterData?.monthly_installment && (
                      <p className="text-[#00AE11] font-[600] mt-2">
                        ${Math.ceil(parseFloat(loanData.counterData.monthly_installment))}
                      </p>
                    )}
                  </td>

                  <td
                    className={
                      loanData?.counterData != null
                        ? "whitespace-nowrap px-5 py-4 text-left text-[13px] font-[400] text-[#F80707]"
                        : "whitespace-nowrap px-5 py-4 text-left text-[13px] font-[400]"
                    }
                  >
                    ${loanData.last_installment != null ? Math.ceil(parseFloat(loanData.last_installment)) : 'N/A'}
                    {loanData?.counterData?.last_installment && (
                      <p className="text-[#00AE11] font-[600] mt-2">
                        ${Math.ceil(parseFloat(loanData.counterData.last_installment))}
                      </p>
                    )}
                  </td>

                </tr>
              )}
            </tbody>

          </table>
        </div>


        <div className="mt-4">
          <p className="text-[14px] font-[600]">
            Select an action for this Loan Application
          </p>
          {/* {} */}

          {/* {actionType && ( */}
          <Radio.Group
            className="radio-group mt-4 w-full"
            // defaultValue=""
            value={actionType}
            onChange={(e) => {
              setActionType(e.target.value);
            }}
          >
            {loanData?.type != "In-House" ? (            //initial tabs changed here
              <Fragment>
                <Row gutter={[24, 24]}>
                  {options.map((option, index) => (
                    <Col xs={24} sm={12} md={8} lg={8} key={`${option.value}-${index}`}>
                      <label
                        className={
                          actionType == option.value
                            ? "flex items-center justify-center p-3 border w-full border-[#1677ff] cursor-pointer"
                            : "flex items-center justify-center p-3 border w-full cursor-pointer"
                        }
                      >
                        <Radio
                          id={option.label}
                          value={option.value}
                          className="mr-2"
                        />
                        <label
                          htmlFor={option.label}
                          className="whitespace-nowrap text-[11px] cursor-pointer"
                        >
                          {option.label}
                        </label>
                        &nbsp;&nbsp;
                        <Popover
                          content={"Coming soon"}
                          className="cursor-pointer"
                        >
                          <InfoCircleOutlined className="ml-auto" />
                        </Popover>
                      </label>
                    </Col>
                  ))}
                </Row>
              </Fragment>
            ) : (
              <Fragment>
                <Row gutter={[24, 24]}>
                  {Inhouseoptions.map((option, index) => (
                    <Col xs={24} sm={12} md={8} lg={6} key={`${option.value}-${index}`}>
                      <label
                        className={
                          actionType === option.value
                            ? "flex items-center justify-center p-3 border w-full border-[#1677ff] cursor-pointer"
                            : "flex items-center justify-center p-3 border w-full cursor-pointer"
                        }
                      >
                        <Radio
                          id={option.label}
                          value={option.value}
                          className="mr-2"
                        />
                        <label
                          htmlFor={option.label}
                          className="whitespace-nowrap text-[11px] cursor-pointer"
                        >
                          {option.label}
                        </label>
                        <Popover content={"Coming soon"} className="cursor-pointer">
                          <InfoCircleOutlined className="ml-auto" />
                        </Popover>
                      </label>
                    </Col>
                  ))}
                </Row>
              </Fragment>
            )}
          </Radio.Group>
          {/* )} */}


          {actionType != "" && (
            <div className="bg-[#F5F5F5] p-5 mt-5 rounded">
              {(actionType == "approve_instant" ||
                actionType == "approve_instant_bank") && (
                  <Fragment>
                    {loanData?.type == "In-House" && (
                      <p className="mt-3 text-[13px] font-[400]">
                        You can issue the AA with a counter offer if there are no
                        changes for the Guarantors Details, if you need applicant
                        to furnish other guarantor(s), select{" "}
                        <span
                          className="cursor-pointer text-[#0660FC]"
                          onClick={() => {
                            setActionType("approve_later");
                          }}
                        >
                          “ Counter Offer But Issue AA Later ”{" "}
                        </span>
                        Option
                      </p>
                    )}
                    <p className="text-[13px] font-[700] mt-2 mb-2">                               {/* added*/}
                      Submit Counter Offer
                    </p>
                    <Formik
                      enableReinitialize={true}
                      initialValues={counterOfferValues}
                    >
                      {(formikProps) => (
                        <Form layout="vertical">
                          <Row gutter={[24, 24]}>
                            <Col xs={24} sm={12} md={8} lg={5}>
                              <label className="form-field-label flex">
                                Interest&nbsp;&nbsp;
                              </label>

                              <Form.Item name="field2" className="mt-1">
                                <Field name="interest" className="interest">
                                  {({ field }) => (
                                    <Input
                                      className="interest"
                                      suffix={<PercentageOutlined />}
                                      {...field}
                                      disabled={true} // Always disabled (read-only)
                                      onBlur={(e) => {
                                        handleChange(e, formikProps);
                                      }}
                                    />
                                  )}
                                </Field>
                              </Form.Item>
                            </Col>

                            <Col xs={24} sm={12} md={8} lg={5}>
                              <label className="form-field-label">
                                Loan Amount&nbsp;&nbsp;
                              </label>
                              <Form.Item name="field2" className="mt-1">
                                <Field name="loanamount">
                                  {({ field }) => (
                                    <Input
                                      prefix={"$"}
                                      {...field}
                                      disabled={disabled.loan_amt}
                                      onBlur={(e) => {
                                        handleChange(e, formikProps);
                                      }}
                                    />
                                  )}
                                </Field>
                              </Form.Item>
                            </Col>
                            <Col xs={24} sm={12} md={8} lg={5}>
                              <Fragment>
                                <label className="form-field-label">
                                  Tenor (mths)&nbsp;&nbsp;
                                </label>
                                <Form.Item name="field2" className="mt-1">
                                  <Field name="tenure">
                                    {({ field }) => (
                                      <Input
                                        {...field}
                                        disabled={disabled.tenure}
                                        onBlur={(e) => {
                                          handleChange(e, formikProps);
                                        }}
                                      />
                                    )}
                                  </Field>
                                </Form.Item>
                              </Fragment>
                            </Col>
                          </Row>
                          <Row gutter={[24, 24]}>
                            <Col xs={24} sm={12} md={8} lg={5}>
                              <label className="form-field-label">
                                Dealer Comm.&nbsp;&nbsp;
                              </label>
                              <Form.Item name="field2" className="mt-1">
                                <Field name="dealer_commission_percentage">
                                  {({ field }) => (
                                    <Input
                                      suffix={<PercentageOutlined />}
                                      {...field}
                                      disabled={disabled.dealer_commission}
                                      onBlur={(e) => {
                                        handleChange(e, formikProps);
                                      }}
                                    />
                                  )}
                                </Field>

                              </Form.Item>
                            </Col>
                            <Col xs={24} sm={12} md={8} lg={5}>
                              <label className="form-field-label">
                                Admin Fee&nbsp;&nbsp;
                              </label>
                              <Form.Item name="field2" className="mt-1">
                                <Field name="admin_fee">
                                  {({ field }) => (
                                    <Input
                                      prefix={"$"}
                                      {...field}
                                      value={
                                        field.value === null || field.value === "" || isNaN(field.value)
                                          ? 0
                                          : Math.round(Number(field.value))
                                      }
                                      disabled={disabled.admin_fee}
                                      onBlur={(e) => {
                                        handleChange(e, formikProps);
                                      }}
                                    />
                                  )}
                                </Field>

                              </Form.Item>
                            </Col>
                            <Col xs={24} sm={12} md={8} lg={5}>
                              <label className="form-field-label">
                                Monthly Installment&nbsp;&nbsp;
                                {disabled.monthly_installment == true ? (
                                  <EditOutlined
                                    onClick={() => {
                                      setdisabled((disabledData) => ({
                                        ...disabledData,
                                        monthly_installment: false,
                                      }));
                                      setIsMonthlyInstallmentEdited(true);
                                    }}
                                    className="cursor-pointer text-[#1677ff] mt-[3px]"
                                  />
                                ) : (
                                  <SyncOutlined
                                    onClick={() => {
                                      setdisabled((disabledData) => ({
                                        ...disabledData,
                                        monthly_installment: true,
                                      }));
                                      formikProps.setFieldValue(
                                        "mnthly_installment",
                                        loanData.mnthly_installment
                                      );
                                      setCounterOfferValues((data) => ({
                                        ...data,
                                        mnthly_installment: loanData.mnthly_installment,
                                      }));
                                      setIsMonthlyInstallmentEdited(false);
                                    }}

                                    className="cursor-pointer text-[#1677ff] mt-[3px]"
                                  />
                                )}
                              </label>

                              <Form.Item name="monthly_installment" className="mt-1">
                                <Field name="monthly_installment">
                                  {({ field }) => (
                                    <Input
                                      prefix="$"
                                      {...field}
                                      disabled={disabled.monthly_installment} // disable when view-only
                                      value={Math.ceil(Number(field.value || 0))}
                                      onChange={(e) => {
                                        const value = Number(e.target.value) || 0;
                                        formikProps.setFieldValue("monthly_installment", value);
                                        setCounterOfferValues((prev) => ({
                                          ...prev,
                                          monthly_installment: value,
                                        }));
                                        setIsMonthlyInstallmentEdited(true); // mark as edited
                                      }}
                                    />
                                  )}
                                </Field>
                              </Form.Item>
                            </Col>
                            <Col xs={24} sm={12} md={8} lg={5}>
                              <label className="form-field-label">
                                Last Installment&nbsp;&nbsp;
                                {disabled.last_installment == true ? (
                                  <EditOutlined
                                    onClick={() => {
                                      setdisabled((disabledData) => ({
                                        ...disabledData,
                                        last_installment: false,
                                      }));
                                      setIsMonthlyInstallmentEdited(true);
                                    }}
                                    className="cursor-pointer text-[#1677ff] mt-[3px]"
                                  />
                                ) : (
                                  <SyncOutlined
                                    onClick={() => {
                                      setdisabled((disabledData) => ({
                                        ...disabledData,
                                        last_installment: true,
                                      }));
                                      const resetLastInstallment = counterOfferValues.last_installment ?? loanData.last_installment ?? '';
                                      formikProps.setFieldValue("last_installment", resetLastInstallment);
                                      setCounterOfferValues((data) => ({
                                        ...data,
                                        last_installment: resetLastInstallment,
                                      }));

                                      setCounterOfferValues((data) => ({
                                        ...data,
                                        last_installment: resetLastInstallment,
                                      }));
                                    }}

                                    className="cursor-pointer text-[#1677ff] mt-[3px]"
                                  />
                                )}
                              </label>

                              <Form.Item name="last_installment" className="mt-1">
                                <Field name="last_installment">
                                  {({ field }) => (
                                    <Input
                                      prefix="$"
                                      {...field}
                                      disabled={disabled.last_installment}
                                      value={Math.ceil(Number(field.value || 0))}
                                      onChange={(e) => {
                                        const value = (e.target.value) || 0;
                                        formikProps.setFieldValue("last_installment", value);
                                        setCounterOfferValues((prev) => ({
                                          ...prev,
                                          last_installment: value,
                                        }));
                                      }}
                                    />
                                  )}
                                </Field>
                              </Form.Item>
                            </Col>
                          </Row>

                          <Row gutter={[24, 24]}>
                            {/* { Terms & Conditions} */}
                            <Col span={10} >
                              <label className="form-field-label">
                                Terms & Conditions
                              </label>
                              <Form.Item name="terms_and_conditions" className="mt-1">
                                <Field name="terms_and_conditions">
                                  {({ field }) => (
                                    <Input.TextArea
                                      {...field}
                                      value={field.value ?? ""}
                                      rows={4}
                                      onChange={(e) => {
                                        const value = e.target.value || "";
                                        formikProps.setFieldValue("terms_and_conditions", value);
                                        setCounterOfferValues((prev) => ({
                                          ...prev,
                                          terms_and_conditions: value,
                                        }));
                                      }}
                                    />
                                  )}
                                </Field>
                              </Form.Item>
                            </Col>
                          </Row>

                          <Row gutter={[24, 24]}>
                            {/* { Remarks} */}
                            <Col span={10}>
                              <label className="form-field-label">
                                Remarks
                              </label>
                              <Form.Item name="remarks" className="mt-1">
                                <Field name="remarks">
                                  {({ field }) => (
                                    <Input.TextArea
                                      {...field}
                                      value={field.value ?? ""}
                                      rows={4}
                                      onChange={(e) => {
                                        const value = e.target.value || "";
                                        formikProps.setFieldValue("remarks", value);
                                        setCounterOfferValues((prev) => ({
                                          ...prev,
                                          remarks: value,
                                        }));
                                      }}
                                    />
                                  )}
                                </Field>
                              </Form.Item>
                            </Col>
                          </Row>
                        </Form>
                      )}
                    </Formik>

                    <p className="text-[13px] font-[700] mt-5">
                      Select Guarantor (
                      {selectedGuarantors.length == 0
                        ? " Max 4 "
                        : " Left " + (4 - selectedGuarantors.length)}
                      )
                    </p>
                    {loanData.available_guarantors.length === 0 && <p className="text-[13px] font-[300] "> No guarantor for this case </p>}
                    <div className="flex guarantor py-4 marginremover">
                      {loanData.available_guarantors != undefined &&
                        loanData.available_guarantors.length > 0 &&
                        loanData.available_guarantors.map((guarantor) => {
                          return (
                            <div
                              key={guarantor.id}
                              onClick={() => {
                                selectGuarantor(guarantor.id);
                              }}
                              className={
                                selectedGuarantors.includes(guarantor.id)
                                  ? "w-full sm:w-1/2 md:w-1/3 lg:w-1/4 xl:w-1/4 px-2 py-2 mb-4 mr-guarantor rounded-lg bg-white cursor-pointer border-1 border-blue-500"
                                  : "w-full sm:w-1/2 md:w-1/3 lg:w-1/4 xl:w-1/4 px-2 py-2 mb-4 mr-guarantor rounded-lg bg-white cursor-pointer border border-[#055FFB]"
                              }
                            >
                              <Row gutter={[24, 24]}>
                                <Col xs={18} sm={12} md={8} lg={20} xl={20}>
                                  <p className="form-field-label">
                                    {guarantor?.guarantor_type == "individual"
                                      ? "Name"
                                      : "Company Name"}
                                  </p>
                                  <p className="text-[12px] font-[500]">
                                    {guarantor?.personal_details?.name
                                      ? guarantor?.personal_details?.name
                                      : guarantor?.personal_details?.company_name}
                                  </p>
                                </Col>
                                <Col xs={6} sm={12} md={8} lg={4} xl={4}>
                                  <img
                                    className="cursor-pointer"
                                    onClick={() => {
                                      localStorage.setItem(
                                        "guarantor_details",
                                        JSON.stringify(guarantor)
                                      );
                                      window.open(
                                        "/agent/guarantor-detail"
                                      );
                                    }}
                                    src="/images/view.png"
                                  />
                                </Col>
                              </Row>
                              <Row gutter={[24, 24]} className="mt-3">
                                <Col xs={24} sm={12} md={8} lg={18} xl={18}>
                                  <p className="form-field-label">
                                    {guarantor?.guarantor_type == "individual"
                                      ? "NRIC (last 4 char.)"
                                      : "UEN/ACRA No (last 4 char.)"}
                                  </p>
                                  <p className="text-[12px] font-[500]">
                                    {guarantor?.personal_details?.uen_acra_no
                                      ? guarantor?.personal_details?.uen_acra_no
                                      : guarantor?.personal_details?.nric}
                                  </p>
                                </Col>
                                <Col xs={24} sm={12} md={8} lg={6} xl={6}>
                                  <p className="form-field-label">Relation</p>
                                  <p className="text-[12px] font-[500]">-</p>
                                </Col>
                              </Row>
                            </div>
                          );
                        })}
                    </div>
                    {/* {loanData?.type != "In-House" && ( */}
                    {/* {(loanData?.type == "In-House" || loanData?.type != "In-House") && ( */}
                    <div className="text-right">
                      <Button
                        disabled={isSavePreview() ? true : false}
                        onClick={() => {
                          UpdateStatus("save");
                        }}
                        type="primary"
                      >
                        Save & Preview AA
                      </Button>
                    </div>
                    {/* )} */}
                  </Fragment>
                )}
              {actionType == "approve_later" && (
                <Fragment>
                  <p className="text-[13px] font-[400] mt-2 mb-2">
                    Use this option if you require the applicant to furnish you
                    with other guarantor(s).
                  </p>
                  <p className="text-[13px] font-[700] mt-2 mb-2">
                    Submit Counter Offer
                  </p>
                  <Formik
                    enableReinitialize={true}
                    initialValues={counterOfferValues}
                  >
                    {(formikProps) => (
                      <Form layout="vertical">
                        <Row gutter={[24, 24]}>
                          <Col xs={24} sm={12} md={8} lg={5}>
                            <label className="form-field-label flex">
                              Interest&nbsp;&nbsp;
                            </label>

                            <Form.Item name="field2" className="mt-1">
                              <Field name="interest" className="interest">
                                {({ field }) => (
                                  <Input
                                    className="interest"
                                    suffix={<PercentageOutlined />}
                                    {...field}
                                    disabled={true} // Always disabled (read-only)
                                    onBlur={(e) => {
                                      handleChange(e, formikProps);
                                    }}
                                  />
                                )}
                              </Field>
                            </Form.Item>
                          </Col>

                          <Col xs={24} sm={12} md={8} lg={5}>
                            <label className="form-field-label">
                              Loan Amount&nbsp;&nbsp;
                            </label>
                            <Form.Item name="field2" className="mt-1">
                              <Field name="loanamount">
                                {({ field }) => (
                                  <Input
                                    prefix={"$"}
                                    {...field}
                                    disabled={disabled.loan_amt}
                                    onBlur={(e) => {
                                      handleChange(e, formikProps);
                                    }}
                                  />
                                )}
                              </Field>
                            </Form.Item>
                          </Col>
                          <Col xs={24} sm={12} md={8} lg={5}>
                            <Fragment>
                              <label className="form-field-label">
                                Tenor (mths)&nbsp;&nbsp;
                              </label>
                              <Form.Item name="field2" className="mt-1">
                                <Field name="tenure">
                                  {({ field }) => (
                                    <Input
                                      {...field}
                                      disabled={disabled.tenure}
                                      onBlur={(e) => {
                                        handleChange(e, formikProps);
                                      }}
                                    />
                                  )}
                                </Field>
                                {/* {validationDetails?.nric?.validation == false &&
                                                            <span className='error'>NRIC Required</span>
                                                        } */}
                              </Form.Item>
                            </Fragment>
                          </Col>
                        </Row>
                        <Row gutter={[24, 24]}>
                          <Col xs={24} sm={12} md={8} lg={5}>
                            <label className="form-field-label">
                              Dealer Comm.&nbsp;&nbsp;
                            </label>
                            <Form.Item name="field2" className="mt-1">
                              <Field name="dealer_commission_percentage">
                                {({ field }) => (
                                  <Input
                                    suffix={<PercentageOutlined />}
                                    {...field}
                                    disabled={disabled.dealer_commission}
                                    onBlur={(e) => {
                                      handleChange(e, formikProps);
                                    }}
                                  />
                                )}
                              </Field>

                            </Form.Item>
                          </Col>
                          <Col xs={24} sm={12} md={8} lg={5}>
                            <label className="form-field-label">
                              Admin Fee&nbsp;&nbsp;
                            </label>
                            <Form.Item name="field2" className="mt-1">
                              <Field name="admin_fee">
                                {({ field }) => (
                                  <Input
                                    prefix={"$"}
                                    {...field}
                                    disabled={disabled.admin_fee}
                                    value={
                                      field.value === null || field.value === "" || isNaN(field.value)
                                        ? 0
                                        : Math.round(Number(field.value))
                                    }
                                    onBlur={(e) => {
                                      handleChange(e, formikProps);
                                    }}
                                  />
                                )}
                              </Field>

                            </Form.Item>
                          </Col>
                          <Col xs={24} sm={12} md={8} lg={5}>
                            <label className="form-field-label">
                              Monthly Installment&nbsp;&nbsp;
                              {disabled.monthly_installment == true ? (
                                <EditOutlined
                                  onClick={() => {
                                    setdisabled((disabledData) => ({
                                      ...disabledData,
                                      monthly_installment: false,
                                    }));
                                    setIsMonthlyInstallmentEdited(true);
                                  }}
                                  className="cursor-pointer text-[#1677ff] mt-[3px]"
                                />
                              ) : (
                                <SyncOutlined
                                  onClick={() => {
                                    setdisabled((disabledData) => ({
                                      ...disabledData,
                                      monthly_installment: true,
                                    }));
                                    formikProps.setFieldValue(
                                      "mnthly_installment",
                                      loanData.mnthly_installment
                                    );
                                    setCounterOfferValues((data) => ({
                                      ...data,
                                      mnthly_installment: loanData.mnthly_installment,
                                    }));
                                    setIsMonthlyInstallmentEdited(false); // back to auto mode
                                  }}

                                  className="cursor-pointer text-[#1677ff] mt-[3px]"
                                />
                              )}
                            </label>

                            <Form.Item name="monthly_installment" className="mt-1">
                              <Field name="monthly_installment">
                                {({ field }) => (
                                  <Input
                                    prefix="$"
                                    {...field}
                                    disabled={disabled.monthly_installment} // disable when view-only
                                    value={Math.ceil(Number(field.value || 0))}
                                    onChange={(e) => {
                                      const value = Number(e.target.value) || 0;
                                      formikProps.setFieldValue("monthly_installment", value);
                                      setCounterOfferValues((prev) => ({
                                        ...prev,
                                        monthly_installment: value,
                                      }));
                                      setIsMonthlyInstallmentEdited(true); // mark as edited
                                    }}
                                  />
                                )}
                              </Field>
                            </Form.Item>

                          </Col>
                          <Col xs={24} sm={12} md={8} lg={5}>
                            <label className="form-field-label">
                              Last Installment&nbsp;&nbsp;
                              {disabled.last_installment == true ? (
                                <EditOutlined
                                  onClick={() => {
                                    setdisabled((disabledData) => ({
                                      ...disabledData,
                                      last_installment: false,
                                    }));
                                    setIsMonthlyInstallmentEdited(true);
                                  }}
                                  className="cursor-pointer text-[#1677ff] mt-[3px]"
                                />
                              ) : (
                                <SyncOutlined
                                  onClick={() => {
                                    setdisabled((disabledData) => ({
                                      ...disabledData,
                                      last_installment: true,
                                    }));
                                    const resetLastInstallment = counterOfferValues.last_installment ?? loanData.last_installment ?? '';
                                    formikProps.setFieldValue("last_installment", resetLastInstallment);
                                    setCounterOfferValues((data) => ({
                                      ...data,
                                      last_installment: resetLastInstallment,
                                    }));

                                    setCounterOfferValues((data) => ({
                                      ...data,
                                      last_installment: resetLastInstallment,
                                    }));
                                  }}

                                  className="cursor-pointer text-[#1677ff] mt-[3px]"
                                />
                              )}
                            </label>

                            <Form.Item name="last_installment" className="mt-1">
                              <Field name="last_installment">
                                {({ field }) => (
                                  <Input
                                    prefix="$"
                                    {...field}
                                    disabled={disabled.last_installment}
                                    value={Math.ceil(Number(field.value || 0))}
                                    onChange={(e) => {
                                      const value = (e.target.value) || 0;
                                      formikProps.setFieldValue("last_installment", value);
                                      setCounterOfferValues((prev) => ({
                                        ...prev,
                                        last_installment: value,
                                      }));
                                    }}
                                  />
                                )}
                              </Field>
                            </Form.Item>
                          </Col>
                        </Row>
                        <Row gutter={[24, 24]}>
                          {/* { Terms & Conditions} */}
                          <Col span={10}>
                            <label className="form-field-label">
                              Terms & Conditions
                            </label>
                            <Form.Item name="terms_and_conditions" className="mt-1">
                              <Field name="terms_and_conditions">
                                {({ field }) => (
                                  <Input.TextArea
                                    {...field}
                                    value={field.value ?? ""}
                                    rows={4}
                                    onChange={(e) => {
                                      const value = e.target.value || "";
                                      formikProps.setFieldValue("terms_and_conditions", value);
                                      setCounterOfferValues((prev) => ({
                                        ...prev,
                                        terms_and_conditions: value,
                                      }));
                                    }}
                                  />
                                )}
                              </Field>
                            </Form.Item>
                          </Col>
                        </Row>
                        <Row gutter={[24, 24]}>
                          {/* { Remarks} */}
                          <Col span={10}>
                            <label className="form-field-label">
                              Remarks
                            </label>

                            <Form.Item name="remarks" className="mt-1">
                              <Field name="remarks">
                                {({ field }) => (
                                  <Input.TextArea
                                    {...field}
                                    value={field.value ?? ""}
                                    rows={4}
                                    onChange={(e) => {
                                      const value = e.target.value || "";
                                      formikProps.setFieldValue("remarks", value);
                                      setCounterOfferValues((prev) => ({
                                        ...prev,
                                        remarks: value,
                                      }));
                                    }}
                                  />
                                )}
                              </Field>
                            </Form.Item>
                          </Col>
                        </Row>
                      </Form>
                    )}
                  </Formik>

                  <div className="flex">
                    <div>
                      <p className="mr-5 text-[13px] font-[700] mt-1 text-center">
                        The AA will be issued at a later date or after
                        applicants select this loan
                      </p>
                    </div>
                  </div>
                  <p className="text-[13px] font-[700] mt-5">
                    Select Guarantor (
                    {selectedGuarantors.length == 0
                      ? " Max 4 "
                      : " Left " + (4 - selectedGuarantors.length)}
                    )
                  </p>
                  {loanData.available_guarantors.length === 0 && <p className="text-[13px] font-[300] "> No guarantor for this case </p>}
                  <div className="flex guarantor py-4 marginremover">
                    {loanData.available_guarantors != undefined &&
                      loanData.available_guarantors.length > 0 &&
                      loanData.available_guarantors.map((guarantor) => {
                        return (
                          <div
                            onClick={() => {
                              selectGuarantor(guarantor.id);
                            }}
                            className={
                              selectedGuarantors.includes(guarantor.id)
                                ? "w-full sm:w-1/2 md:w-1/3 lg:w-1/4 xl:w-1/4 px-2 py-2 mb-4 mr-guarantor rounded-lg bg-white cursor-pointer border-1 border-blue-500"
                                : "w-full sm:w-1/2 md:w-1/3 lg:w-1/4 xl:w-1/4 px-2 py-2 mb-4 mr-guarantor rounded-lg bg-white cursor-pointer border border-[#055FFB]"
                            }
                          >
                            <Row gutter={[24, 24]}>
                              <Col xs={18} sm={12} md={8} lg={20} xl={20}>
                                <p className="form-field-label">
                                  {guarantor?.guarantor_type == "individual"
                                    ? "Name"
                                    : "Company Name"}
                                </p>
                                <p className="text-[12px] font-[500]">
                                  {guarantor?.personal_details?.name
                                    ? guarantor?.personal_details?.name
                                    : guarantor?.personal_details?.company_name}
                                </p>
                              </Col>
                              <Col xs={6} sm={12} md={8} lg={4} xl={4}>
                                <img
                                  className="cursor-pointer"
                                  onClick={() => {
                                    localStorage.setItem(
                                      "guarantor_details",
                                      JSON.stringify(guarantor)
                                    );
                                    window.open(
                                      "/agent/guarantor-detail"
                                    );
                                  }}
                                  src="/images/view.png"
                                />
                              </Col>
                            </Row>
                            <Row gutter={[24, 24]} className="mt-3">
                              <Col xs={24} sm={12} md={8} lg={18} xl={18}>
                                <p className="form-field-label">
                                  {guarantor?.guarantor_type == "individual"
                                    ? "NRIC (last 4 char.)"
                                    : "UEN/ACRA No (last 4 char.)"}
                                </p>
                                <p className="text-[12px] font-[500]">
                                  {guarantor?.personal_details?.uen_acra_no
                                    ? guarantor?.personal_details?.uen_acra_no
                                    : guarantor?.personal_details?.nric}
                                </p>
                              </Col>
                              <Col xs={24} sm={12} md={8} lg={6} xl={6}>
                                <p className="form-field-label">Relation</p>
                                <p className="text-[12px] font-[500]">-</p>
                              </Col>
                            </Row>
                          </div>
                        );
                      })}
                  </div>


                </Fragment>
              )}
              {actionType == "counter_later" && (
                <Fragment>
                  <p className="text-[13px] font-[400] mt-2 mb-2">
                    Use this option if you require the applicant to furnish you
                    with other guarantor(s).
                  </p>
                  <p className="text-[13px] font-[700] mt-2 mb-2">
                    Submit Counter Offer
                  </p>
                  <Formik
                    enableReinitialize={true}
                    initialValues={counterOfferValues}
                  >
                    {(formikProps) => (
                      <Form layout="vertical">
                        <Row gutter={[24, 24]}>
                          <Col xs={24} sm={12} md={8} lg={5}>
                            <label className="form-field-label flex">
                              Interest&nbsp;&nbsp;
                              {disabled.interest == true ? (
                                <EditOutlined
                                  onClick={() => {
                                    setdisabled((disabledData) => ({
                                      ...disabledData,
                                      interest: false,
                                    }));
                                  }}
                                  className="cursor-pointer text-[#1677ff] mt-[3px]"
                                />
                              ) : (
                                <SyncOutlined
                                  onClick={() => {
                                    setdisabled((disabledData) => ({
                                      ...disabledData,
                                      interest: true,
                                    }));
                                    ;
                                    formikProps.setFieldValue(
                                      "interest",
                                      loanData.interest
                                    );
                                    ;
                                    setCounterOfferValues((data) => ({
                                      ...data,
                                      interest: loanData.interest,
                                    }));
                                  }}
                                  className="cursor-pointer text-[#1677ff] mt-[3px]"
                                />
                              )}
                            </label>
                            <Form.Item name="field2" className="mt-1">
                              <Field name="interest" className="interest">
                                {({ field }) => (
                                  <Input
                                    className="interest"
                                    suffix={<PercentageOutlined />}
                                    {...field}
                                    disabled={disabled.interest}
                                    onBlur={(e) => {
                                      handleChange(e, formikProps);
                                    }}
                                  />
                                )}
                              </Field>
                              {/* {validationDetails?.name?.validation == false &&
                                                        <span className='error'>Name Required</span>
                                                    } */}
                            </Form.Item>
                          </Col>
                          <Col xs={24} sm={12} md={8} lg={5}>
                            <label className="form-field-label">
                              Loan Amount&nbsp;&nbsp;
                              {disabled.loan_amt == true ? (
                                <EditOutlined
                                  onClick={() => {
                                    setdisabled((disabledData) => ({
                                      ...disabledData,
                                      loan_amt: false,
                                    }));
                                  }}
                                  className="cursor-pointer text-[#1677ff] mt-[3px]"
                                />
                              ) : (
                                <SyncOutlined
                                  onClick={() => {
                                    setdisabled((disabledData) => ({
                                      ...disabledData,
                                      loan_amt: true,
                                    }));
                                    ;
                                    formikProps.setFieldValue(
                                      "loanamount",
                                      loanData.loan_amt
                                    );
                                    ;
                                    setCounterOfferValues((data) => ({
                                      ...data,
                                      loanamount: loanData.loan_amt,
                                    }));
                                  }}
                                  className="cursor-pointer text-[#1677ff] mt-[3px]"
                                />
                              )}
                            </label>
                            <Form.Item name="field2" className="mt-1">
                              <Field name="loanamount">
                                {({ field }) => (
                                  <Input
                                    prefix={"$"}
                                    {...field}
                                    disabled={disabled.loan_amt}
                                    onBlur={(e) => {
                                      handleChange(e, formikProps);
                                    }}
                                  />
                                )}
                              </Field>
                            </Form.Item>
                          </Col>
                          <Col xs={24} sm={12} md={8} lg={5}>
                            <Fragment>
                              <label className="form-field-label">
                                Tenor (mths)&nbsp;&nbsp;
                                {disabled.tenure == true ? (
                                  <EditOutlined
                                    onClick={() => {
                                      setdisabled((disabledData) => ({
                                        ...disabledData,
                                        tenure: false,
                                      }));
                                    }}
                                    className="cursor-pointer text-[#1677ff] mt-[3px]"
                                  />
                                ) : (
                                  <SyncOutlined
                                    onClick={() => {
                                      setdisabled((disabledData) => ({
                                        ...disabledData,
                                        tenure: true,
                                      }));
                                      ;
                                      formikProps.setFieldValue(
                                        "tenure",
                                        loanData.tenor
                                      );
                                      ;
                                      setCounterOfferValues((data) => ({
                                        ...data,
                                        tenure: loanData.tenor,
                                      }));
                                    }}
                                    className="cursor-pointer text-[#1677ff] mt-[3px]"
                                  />
                                )}
                              </label>
                              <Form.Item name="field2" className="mt-1">
                                <Field name="tenure">
                                  {({ field }) => (
                                    <Input
                                      {...field}
                                      disabled={disabled.tenure}
                                      onBlur={(e) => {
                                        handleChange(e, formikProps);
                                      }}
                                    />
                                  )}
                                </Field>
                              </Form.Item>
                            </Fragment>
                          </Col>
                        </Row>
                        <Row gutter={[24, 24]}>
                          <Col xs={24} sm={12} md={8} lg={5}>
                            <label className="form-field-label">
                              Dealer Comm.&nbsp;&nbsp;
                              {disabled.dealer_commission == true ? (
                                <EditOutlined
                                  onClick={() => {
                                    setdisabled((disabledData) => ({
                                      ...disabledData,
                                      dealer_commission: false,
                                    }));
                                  }}
                                  className="cursor-pointer text-[#1677ff] mt-[3px]"
                                />
                              ) : (
                                <SyncOutlined
                                  onClick={() => {
                                    setdisabled((disabledData) => ({
                                      ...disabledData,
                                      dealer_commission: true,
                                    }));
                                    ;
                                    formikProps.setFieldValue(
                                      "dealer_commission_percentage",
                                      loanData.dealer_commission_percentage
                                    );
                                    ;
                                    setCounterOfferValues((data) => ({
                                      ...data,
                                      dealer_commission_percentage:
                                        loanData.dealer_commission_percentage,
                                    }));
                                  }}
                                  className="cursor-pointer text-[#1677ff] mt-[3px]"
                                />
                              )}
                            </label>
                            <Form.Item name="field2" className="mt-1">
                              <Field name="dealer_commission_percentage">
                                {({ field }) => (
                                  <Input
                                    suffix={<PercentageOutlined />}
                                    {...field}
                                    disabled={disabled.dealer_commission}
                                    onBlur={(e) => {
                                      handleChange(e, formikProps);
                                    }}
                                  />
                                )}
                              </Field>
                            </Form.Item>
                          </Col>
                          <Col xs={24} sm={12} md={8} lg={5}>
                            <label className="form-field-label">
                              Admin Fee&nbsp;&nbsp;
                              {disabled.admin_fee == true ? (
                                <EditOutlined
                                  onClick={() => {
                                    setdisabled((disabledData) => ({
                                      ...disabledData,
                                      admin_fee: false,
                                    }));
                                  }}
                                  className="cursor-pointer text-[#1677ff] mt-[3px]"
                                />
                              ) : (
                                <SyncOutlined
                                  onClick={() => {
                                    setdisabled((disabledData) => ({
                                      ...disabledData,
                                      admin_fee: true,
                                    }));
                                    ;
                                    formikProps.setFieldValue(
                                      "admin_fee",
                                      // loanData.admin_fee
                                      loanData.admin_fee ? Number(loanData.admin_fee) : 0
                                    );
                                    ;
                                    setCounterOfferValues((data) => ({
                                      ...data,
                                      admin_fee: loanData.admin_fee ? Number(loanData.admin_fee) : 0
                                    }));
                                  }}
                                  className="cursor-pointer text-[#1677ff] mt-[3px]"
                                />
                              )}
                            </label>
                            <Form.Item name="field2" className="mt-1">
                              <Field name="admin_fee">
                                {({ field }) => (
                                  <Input
                                    prefix={"$"}
                                    {...field}
                                    disabled={disabled.admin_fee}
                                    value={
                                      field.value === null || field.value === "" || isNaN(field.value)
                                        ? 0
                                        : Math.round(Number(field.value))
                                    }
                                    onBlur={(e) => {
                                      handleChange(e, formikProps);
                                    }}
                                  />
                                )}
                              </Field>
                            </Form.Item>
                          </Col>

                          <Col xs={24} sm={12} md={8} lg={5}>
                            <label className="form-field-label">
                              Monthly Installment&nbsp;&nbsp;
                              {disabled.monthly_installment == true ? (
                                <EditOutlined
                                  onClick={() => {
                                    setdisabled((disabledData) => ({
                                      ...disabledData,
                                      monthly_installment: false,
                                    }));
                                    setIsMonthlyInstallmentEdited(true); // user will now edit
                                  }}
                                  className="cursor-pointer text-[#1677ff] mt-[3px]"
                                />
                              ) : (
                                <SyncOutlined
                                  onClick={() => {
                                    setdisabled((disabledData) => ({
                                      ...disabledData,
                                      monthly_installment: true,
                                    }));
                                    formikProps.setFieldValue(
                                      "mnthly_installment",
                                      loanData.mnthly_installment
                                    );
                                    setCounterOfferValues((data) => ({
                                      ...data,
                                      mnthly_installment: loanData.mnthly_installment,
                                    }));
                                    setIsMonthlyInstallmentEdited(false); // back to auto mode
                                  }}

                                  className="cursor-pointer text-[#1677ff] mt-[3px]"
                                />
                              )}
                            </label>

                            <Form.Item name="monthly_installment" className="mt-1">
                              <Field name="monthly_installment">
                                {({ field }) => (
                                  <Input
                                    prefix="$"
                                    {...field}
                                    disabled={disabled.monthly_installment} // disable when view-only
                                    value={Math.ceil(Number(field.value || 0))}
                                    onChange={(e) => {
                                      const value = Number(e.target.value) || 0;
                                      formikProps.setFieldValue("monthly_installment", value);
                                      setCounterOfferValues((prev) => ({
                                        ...prev,
                                        monthly_installment: value,
                                      }));
                                      setIsMonthlyInstallmentEdited(true); // mark as edited
                                    }}
                                  />
                                )}
                              </Field>
                            </Form.Item>
                          </Col>

                          {/* { Last Installment} */}
                          <Col xs={24} sm={12} md={8} lg={5}>
                            <label className="form-field-label">
                              Last Installment&nbsp;&nbsp;
                              {disabled.last_installment == true ? (
                                <EditOutlined
                                  onClick={() => {
                                    setdisabled((disabledData) => ({
                                      ...disabledData,
                                      last_installment: false,
                                    }));
                                    setIsMonthlyInstallmentEdited(true);
                                  }}
                                  className="cursor-pointer text-[#1677ff] mt-[3px]"
                                />
                              ) : (
                                <SyncOutlined
                                  onClick={() => {
                                    setdisabled((disabledData) => ({
                                      ...disabledData,
                                      last_installment: true,
                                    }));
                                    const resetLastInstallment = counterOfferValues.last_installment ?? loanData.last_installment ?? '';
                                    formikProps.setFieldValue("last_installment", resetLastInstallment);
                                    setCounterOfferValues((data) => ({
                                      ...data,
                                      last_installment: resetLastInstallment,
                                    }));

                                    setCounterOfferValues((data) => ({
                                      ...data,
                                      last_installment: resetLastInstallment,
                                    }));
                                    // setIsMonthlyInstallmentEdited(false);
                                  }}

                                  className="cursor-pointer text-[#1677ff] mt-[3px]"
                                />
                              )}
                            </label>

                            <Form.Item name="last_installment" className="mt-1">
                              <Field name="last_installment">
                                {({ field }) => (
                                  <Input
                                    prefix="$"
                                    {...field}
                                    disabled={disabled.last_installment}
                                    // value={Number(field.value || 0).toFixed(2)}
                                    value={Math.ceil(Number(field.value || 0))}
                                    onChange={(e) => {
                                      const value = e.target.value || 0;
                                      formikProps.setFieldValue("last_installment", value);
                                      setCounterOfferValues((prev) => ({
                                        ...prev,
                                        last_installment: value,
                                      }));
                                      setIsMonthlyInstallmentEdited(true); // mark as edited
                                    }}
                                  />
                                )}
                              </Field>
                            </Form.Item>

                          </Col>
                        </Row>
                        <Row gutter={[24, 24]}>
                          {/* { Terms & Conditions} */}
                          <Col span={10}>
                            <label className="form-field-label">
                              Terms & Conditions
                            </label>
                            <Form.Item name="terms_and_conditions" className="mt-1">
                              <Field name="terms_and_conditions">
                                {({ field }) => (
                                  <Input.TextArea
                                    {...field}
                                    value={field.value ?? ""}
                                    rows={4}
                                    onChange={(e) => {
                                      const value = e.target.value || "";
                                      formikProps.setFieldValue("terms_and_conditions", value);
                                      setCounterOfferValues((prev) => ({
                                        ...prev,
                                        terms_and_conditions: value,
                                      }));
                                    }}
                                  />
                                )}
                              </Field>
                            </Form.Item>
                          </Col>
                        </Row>
                        <Row gutter={[24, 24]}>
                          {/* { Remarks} */}
                          <Col span={10}>
                            <label className="form-field-label">
                              Remarks
                            </label>

                            <Form.Item name="remarks" className="mt-1">
                              <Field name="remarks">
                                {({ field }) => (
                                  <Input.TextArea
                                    {...field}
                                    value={field.value ?? ""}
                                    rows={4}
                                    onChange={(e) => {
                                      const value = e.target.value || "";
                                      formikProps.setFieldValue("remarks", value);
                                      setCounterOfferValues((prev) => ({
                                        ...prev,
                                        remarks: value,
                                      }));
                                    }}
                                  />
                                )}
                              </Field>
                            </Form.Item>
                          </Col>
                        </Row>
                      </Form>
                    )}
                  </Formik>
                  <p className="text-[13px] font-[700] mt-5">
                    Select Guarantor (
                    {selectedGuarantors.length == 0
                      ? " Max 4 "
                      : " Left " + (4 - selectedGuarantors.length)}
                    )
                  </p>
                  {loanData.available_guarantors.length === 0 && <p className="text-[13px] font-[300] "> No guarantor for this case </p>}
                  <div className="flex guarantor py-4">
                    {loanData.available_guarantors != undefined &&
                      loanData.available_guarantors.length > 0 &&
                      loanData.available_guarantors.map((guarantor) => {
                        return (
                          <div
                            onClick={() => {
                              selectGuarantor(guarantor.id);
                            }}
                            className={
                              selectedGuarantors.includes(guarantor.id)
                                ? "w-full sm:w-1/2 md:w-1/3 lg:w-1/4 xl:w-1/4 px-2 py-2 mb-4 mr-guarantor rounded-lg bg-white cursor-pointer border-1 border-blue-500"
                                : "w-full sm:w-1/2 md:w-1/3 lg:w-1/4 xl:w-1/4 px-2 py-2 mb-4 mr-guarantor rounded-lg bg-white cursor-pointer border border-[#055FFB]"
                            }
                          >
                            <Row gutter={[24, 24]}>
                              <Col xs={18} sm={12} md={8} lg={20} xl={20}>
                                <p className="form-field-label">
                                  {guarantor?.guarantor_type == "individual"
                                    ? "Name"
                                    : "Company Name"}
                                </p>
                                <p className="text-[12px] font-[500]">
                                  {guarantor?.personal_details?.name
                                    ? guarantor?.personal_details?.name
                                    : guarantor?.personal_details?.company_name}
                                </p>
                              </Col>
                              <Col xs={6} sm={12} md={8} lg={4} xl={4}>
                                <img
                                  className="cursor-pointer"
                                  onClick={() => {
                                    localStorage.setItem(
                                      "guarantor_details",
                                      JSON.stringify(guarantor)
                                    );
                                    window.open(
                                      "/agent/guarantor-detail"
                                    );
                                  }}
                                  src="/images/view.png"
                                />
                              </Col>
                            </Row>
                            <Row gutter={[24, 24]} className="mt-3">
                              <Col xs={24} sm={12} md={8} lg={18} xl={18}>
                                <p className="form-field-label">
                                  {guarantor?.guarantor_type == "individual"
                                    ? "NRIC (last 4 char.)"
                                    : "UEN/ACRA No (last 4 char.)"}
                                </p>
                                <p className="text-[12px] font-[500]">
                                  {guarantor?.personal_details?.uen_acra_no
                                    ? guarantor?.personal_details?.uen_acra_no
                                    : guarantor?.personal_details?.nric}
                                </p>
                              </Col>
                              <Col xs={24} sm={12} md={8} lg={6} xl={6}>
                                <p className="form-field-label">Relation</p>
                                <p className="text-[12px] font-[500]">-</p>
                              </Col>
                            </Row>
                          </div>
                        );
                      })}
                  </div>
                  <p className="text-[13px] font-[700] mt-2 mb-2">
                    Guarantor Confirmation
                  </p>
                  <div className="bg-white">
                    <div className=" p-5">
                      <div className="overflow-x-hidden">
                        <p className="text-[13px] font-[700] mb-3">
                          Furnish Guarantors:
                        </p>
                      </div>
                      <Fragment>
                        <p className="text-[13px] font-[500] mb-3">
                          Please state if any additional guarantor(s) are
                          required & what are the requirements such as relation
                          and min. income.
                        </p>
                        <p className="text-[13px] font-[500] mb-3">
                          Additional Guarantor(s)
                        </p>
                        <InputNumber
                          min={1}
                          max={3}
                          onChange={onChange}
                          className="mb-3"
                        />
                        {renderRows()}
                      </Fragment>
                    </div>
                    <div className="text-left mx-5 mt-5 mr-5 pb-5">
                      <Button
                        disabled={
                          furnishGuarantorCounts == 0 || !furnishGuarantorCounts
                            ? true
                            : false
                        }
                        onClick={() => {
                          UpdateStatus("confirmstay");
                        }}
                        type="primary"
                      >
                        Confirm
                      </Button>
                    </div>
                  </div>
                  <div className="mt-5 text-right">
                    <Button
                      onClick={() => {
                        UpdateStatus("counter");
                      }}
                      type="primary"
                    >
                      Submit
                    </Button>
                  </div>
                </Fragment>
              )}
              {actionType == "counter_instant" && (
                <Fragment>
                  {/* changed */}
                  {loanData?.type == "In-House" && (
                    <p className="mt-3 text-[13px] font-[400]">
                      You can issue the AA with a counter offer if there are no
                      changes for the Guarantors Details, if you need applicant
                      to furnish other guarantor(s), select{" "}
                      <span
                        className="cursor-pointer text-[#0660FC]"
                        onClick={() => {
                          setActionType("counter_later");
                        }}
                      >
                        “ Counter Offer But Issue AA Later ”{" "}
                      </span>
                      Option
                    </p>
                  )}
                  <p className="text-[13px] font-[700] mt-2 mb-2">
                    Submit Counter Offer
                  </p>
                  <Formik
                    enableReinitialize={true}
                    initialValues={counterOfferValues}
                  >
                    {/* Counter Interest  */}
                    {(formikProps) => (
                      <Form layout="vertical">
                        <Row gutter={[24, 24]}>
                          <Col xs={24} sm={12} md={8} lg={5}>
                            <label className="form-field-label flex">
                              Interest&nbsp;&nbsp;
                              {disabled.interest == true ? (
                                <EditOutlined
                                  onClick={() => {
                                    setdisabled((disabledData) => ({
                                      ...disabledData,
                                      interest: false,
                                    }));
                                  }}
                                  className="cursor-pointer text-[#1677ff] mt-[3px]"
                                />
                              ) : (
                                <SyncOutlined
                                  onClick={() => {
                                    setdisabled((disabledData) => ({
                                      ...disabledData,
                                      interest: true,
                                    }));
                                    const resetInterest = counterOfferValues.interest ?? loanData.interest;
                                    formikProps.setFieldValue("interest", resetInterest);

                                    setCounterOfferValues((data) => ({
                                      ...data,
                                      interest: resetInterest,
                                    }));
                                  }}
                                  className="cursor-pointer text-[#1677ff] mt-[3px]"
                                />
                              )}
                            </label>

                            <Form.Item name="field2" className="mt-1">
                              <Field name="interest" className="interest">
                                {({ field }) => (
                                  <Input
                                    className="interest"
                                    suffix={<PercentageOutlined />}
                                    {...field}
                                    disabled={disabled.interest}
                                    onBlur={(e) => {
                                      handleChange(e, formikProps);
                                    }}
                                  />
                                )}
                              </Field>
                            </Form.Item>
                          </Col>
                          <Col xs={24} sm={12} md={8} lg={5}>
                            <label className="form-field-label">
                              Loan Amount&nbsp;&nbsp;
                              {disabled.loan_amt ? (
                                <EditOutlined
                                  onClick={() => {
                                    setdisabled((prev) => ({
                                      ...prev,
                                      loan_amt: false,
                                    }));
                                  }}
                                  className="cursor-pointer text-[#1677ff] mt-[3px]"
                                />
                              ) : (
                                <SyncOutlined
                                  onClick={() => {
                                    setdisabled((prev) => ({
                                      ...prev,
                                      loan_amt: true,
                                    }));
                                    const resetLoanAmount = counterOfferValues.loanamount ?? loanData.loan_amt;
                                    formikProps.setFieldValue("loanamount", resetLoanAmount);
                                    setCounterOfferValues((prev) => ({
                                      ...prev,
                                      loanamount: resetLoanAmount,
                                    }));
                                  }}
                                  className="cursor-pointer text-[#1677ff] mt-[3px]"
                                />
                              )}
                            </label>

                            <Form.Item name="field2" className="mt-1">
                              <Field name="loanamount">
                                {({ field }) => (
                                  <Input
                                    prefix="$"
                                    {...field}
                                    disabled={disabled.loan_amt}
                                    onBlur={(e) => {
                                      handleChange(e, formikProps);
                                    }}
                                  />
                                )}
                              </Field>
                            </Form.Item>
                          </Col>
                          <Col xs={24} sm={12} md={8} lg={5}>
                            <Fragment>
                              <label className="form-field-label">
                                Tenor (mths)&nbsp;&nbsp;
                                {disabled.tenure === true ? (
                                  <EditOutlined
                                    onClick={() => {
                                      setdisabled((disabledData) => ({
                                        ...disabledData,
                                        tenure: false,
                                      }));
                                    }}
                                    className="cursor-pointer text-[#1677ff] mt-[3px]"
                                  />
                                ) : (
                                  <SyncOutlined
                                    onClick={() => {
                                      setdisabled((disabledData) => ({
                                        ...disabledData,
                                        tenure: true,
                                      }));
                                      const resetTenure = counterOfferValues.tenure ?? loanData.tenor;
                                      formikProps.setFieldValue("tenure", resetTenure);
                                      setCounterOfferValues((data) => ({
                                        ...data,
                                        tenure: resetTenure,
                                      }));
                                    }}
                                    className="cursor-pointer text-[#1677ff] mt-[3px]"
                                  />
                                )}
                              </label>
                              <Form.Item name="field2" className="mt-1">
                                <Field name="tenure">
                                  {({ field }) => (
                                    <Input
                                      {...field}
                                      disabled={disabled.tenure}
                                      onBlur={(e) => {
                                        handleChange(e, formikProps);
                                      }}
                                    />
                                  )}
                                </Field>
                              </Form.Item>
                            </Fragment>
                          </Col>
                        </Row>

                        <Row gutter={[24, 24]}>
                          <Col xs={24} sm={12} md={8} lg={5}>
                            <label className="form-field-label">
                              Dealer Comm.&nbsp;&nbsp;
                              {disabled.dealer_commission ? (
                                <EditOutlined
                                  onClick={() => {
                                    setdisabled((disabledData) => ({
                                      ...disabledData,
                                      dealer_commission: false,
                                    }));
                                  }}
                                  className="cursor-pointer text-[#1677ff] mt-[3px]"
                                />
                              ) : (
                                <SyncOutlined
                                  onClick={() => {
                                    setdisabled((disabledData) => ({
                                      ...disabledData,
                                      dealer_commission: true,
                                    }));
                                    const resetDealerComm =
                                      counterOfferValues.dealer_commission_percentage ??
                                      loanData.dealer_commission_percentage;
                                    formikProps.setFieldValue(
                                      "dealer_commission_percentage",
                                      resetDealerComm
                                    );
                                    setCounterOfferValues((data) => ({
                                      ...data,
                                      dealer_commission_percentage: resetDealerComm,
                                    }));
                                  }}
                                  className="cursor-pointer text-[#1677ff] mt-[3px]"
                                />
                              )}
                            </label>
                            <Form.Item name="field2" className="mt-1">
                              <Field name="dealer_commission_percentage">
                                {({ field }) => (
                                  <Input
                                    suffix={<PercentageOutlined />}
                                    {...field}
                                    disabled={disabled.dealer_commission}
                                    onBlur={(e) => {
                                      handleChange(e, formikProps);
                                    }}
                                  />
                                )}
                              </Field>
                            </Form.Item>
                          </Col>

                          <Col xs={24} sm={12} md={8} lg={5}>
                            <label className="form-field-label">
                              Admin Fee&nbsp;&nbsp;
                              {disabled.admin_fee ? (
                                <EditOutlined
                                  onClick={() => {
                                    setdisabled((disabledData) => ({
                                      ...disabledData,
                                      admin_fee: false,
                                    }));
                                  }}
                                  className="cursor-pointer text-[#1677ff] mt-[3px]"
                                />
                              ) : (
                                <SyncOutlined
                                  onClick={() => {
                                    setdisabled((disabledData) => ({
                                      ...disabledData,
                                      admin_fee: true,
                                    }));
                                    const resetAdminFee =
                                      counterOfferValues.admin_fee ??
                                      (loanData.admin_fee ? Number(loanData.admin_fee) : 0);
                                    formikProps.setFieldValue("admin_fee", resetAdminFee);
                                    setCounterOfferValues((data) => ({
                                      ...data,
                                      admin_fee: resetAdminFee,
                                    }));
                                  }}
                                  className="cursor-pointer text-[#1677ff] mt-[3px]"
                                />
                              )}
                            </label>
                            <Form.Item name="field2" className="mt-1">
                              <Field name="admin_fee">
                                {({ field }) => (
                                  <Input
                                    prefix={"$"}
                                    {...field}
                                    disabled={disabled.admin_fee}
                                    value={
                                      field.value === null || field.value === "" || isNaN(field.value)
                                        ? 0
                                        : Math.round(Number(field.value))
                                    }
                                    onBlur={(e) => {
                                      handleChange(e, formikProps);
                                    }}
                                  />
                                )}
                              </Field>
                            </Form.Item>
                          </Col>

                          {/* data================== */}
                          <Col xs={24} sm={12} md={8} lg={5}>
                            <label className="form-field-label">
                              Monthly Installment&nbsp;&nbsp;
                              {disabled.monthly_installment == true ? (
                                <EditOutlined
                                  onClick={() => {
                                    setdisabled((disabledData) => ({
                                      ...disabledData,
                                      monthly_installment: false,
                                    }));
                                    setIsMonthlyInstallmentEdited(true);
                                  }}
                                  className="cursor-pointer text-[#1677ff] mt-[3px]"
                                />
                              ) : (
                                <SyncOutlined
                                  onClick={() => {
                                    setdisabled((disabledData) => ({
                                      ...disabledData,
                                      monthly_installment: true,
                                    }));
                                    formikProps.setFieldValue(
                                      "mnthly_installment",
                                      loanData.mnthly_installment
                                    );
                                    setCounterOfferValues((data) => ({
                                      ...data,
                                      mnthly_installment: loanData.mnthly_installment,
                                    }));
                                    setIsMonthlyInstallmentEdited(false);
                                  }}

                                  className="cursor-pointer text-[#1677ff] mt-[3px]"
                                />
                              )}
                            </label>

                            <Form.Item name="monthly_installment" className="mt-1">
                              <Field name="monthly_installment">
                                {({ field }) => (
                                  <Input
                                    step="any"
                                    prefix="$"
                                    {...field}
                                    disabled={disabled.monthly_installment}
                                    value={Math.ceil(Number(field.value || 0))}
                                    onChange={(e) => {
                                      const value = e.target.value || 0;
                                      formikProps.setFieldValue("monthly_installment", value);
                                      setCounterOfferValues((prev) => ({
                                        ...prev,
                                        monthly_installment: value,
                                      }));
                                      setIsMonthlyInstallmentEdited(true);
                                    }}
                                  />
                                )}
                              </Field>
                            </Form.Item>
                          </Col>

                          {/* { Last Installment} */}
                          <Col xs={24} sm={12} md={8} lg={5}>
                            <label className="form-field-label">
                              Last Installment&nbsp;&nbsp;
                              {disabled.last_installment == true ? (
                                <EditOutlined
                                  onClick={() => {
                                    setdisabled((disabledData) => ({
                                      ...disabledData,
                                      last_installment: false,
                                    }));
                                  }}
                                  className="cursor-pointer text-[#1677ff] mt-[3px]"
                                />
                              ) : (
                                <SyncOutlined
                                  onClick={() => {
                                    setdisabled((disabledData) => ({
                                      ...disabledData,
                                      last_installment: true,
                                    }));
                                    const resetLastInstallment = counterOfferValues.last_installment ?? loanData.last_installment ?? '';
                                    formikProps.setFieldValue("last_installment", resetLastInstallment);
                                    setCounterOfferValues((data) => ({
                                      ...data,
                                      last_installment: resetLastInstallment,
                                    }));

                                    setCounterOfferValues((data) => ({
                                      ...data,
                                      last_installment: resetLastInstallment,
                                    }));
                                  }}

                                  className="cursor-pointer text-[#1677ff] mt-[3px]"
                                />
                              )}
                            </label>

                            <Form.Item name="last_installment" className="mt-1">
                              <Field name="last_installment">
                                {({ field }) => (
                                  <Input
                                    prefix="$"
                                    {...field}
                                    disabled={disabled.last_installment}
                                    value={Math.ceil(Number(field.value || 0))}
                                    onChange={(e) => {
                                      const value = Number(e.target.value) || 0;
                                      formikProps.setFieldValue("last_installment", value);
                                      setCounterOfferValues((prev) => ({
                                        ...prev,
                                        last_installment: value,
                                      }));
                                      setIsMonthlyInstallmentEdited(true); // mark as edited
                                    }}
                                  />
                                )}
                              </Field>
                            </Form.Item>


                          </Col>
                        </Row>
                        <Row gutter={[24, 24]}>
                          {/* { Terms & Conditions} */}
                          <Col span={10}>
                            <label className="form-field-label">
                              Terms & Conditions
                            </label>
                            <Form.Item name="terms_and_conditions" className="mt-1">
                              <Field name="terms_and_conditions">
                                {({ field }) => (
                                  <Input.TextArea
                                    {...field}
                                    value={field.value ?? ""}
                                    rows={4}
                                    onChange={(e) => {
                                      const value = e.target.value || "";
                                      formikProps.setFieldValue("terms_and_conditions", value);
                                      setCounterOfferValues((prev) => ({
                                        ...prev,
                                        terms_and_conditions: value,
                                      }));
                                    }}
                                  />
                                )}
                              </Field>
                            </Form.Item>
                          </Col>
                        </Row>
                        <Row gutter={[24, 24]}>
                          {/* { Remarks} */}
                          <Col span={10}>
                            <label className="form-field-label">
                              Remarks
                            </label>

                            <Form.Item name="remarks" className="mt-1">
                              <Field name="remarks">
                                {({ field }) => (
                                  <Input.TextArea
                                    {...field}
                                    value={field.value ?? ""}
                                    rows={4}
                                    onChange={(e) => {
                                      const value = e.target.value || "";
                                      formikProps.setFieldValue("remarks", value);
                                      setCounterOfferValues((prev) => ({
                                        ...prev,
                                        remarks: value,
                                      }));
                                    }}
                                  />
                                )}
                              </Field>
                            </Form.Item>
                          </Col>
                        </Row>
                      </Form>
                    )}
                  </Formik>
                  <p className="text-[13px] font-[700] mt-5">
                    Select Guarantor (
                    {selectedGuarantors.length == 0
                      ? " Max 4 "
                      : " Left " + (4 - selectedGuarantors.length)}
                    )
                  </p>
                  {loanData.available_guarantors.length === 0 && <p className="text-[13px] font-[300] "> No guarantor for this case </p>}
                  <div className="flex guarantor py-4 marginremover">
                    {loanData.available_guarantors != undefined &&
                      loanData.available_guarantors.length > 0 &&
                      loanData.available_guarantors.map((guarantor) => {
                        return (
                          <div
                            onClick={() => {
                              selectGuarantor(guarantor.id);
                            }}
                            className={
                              selectedGuarantors.includes(guarantor.id)
                                ? "w-full sm:w-1/2 md:w-1/3 lg:w-1/4 xl:w-1/4 px-2 py-2 mb-4 mr-guarantor rounded-lg bg-white cursor-pointer border-1 border-blue-500"
                                : "w-full sm:w-1/2 md:w-1/3 lg:w-1/4 xl:w-1/4 px-2 py-2 mb-4 mr-guarantor rounded-lg bg-white cursor-pointer border border-[#055FFB]"
                            }
                          >
                            <Row gutter={[24, 24]}>
                              <Col xs={18} sm={12} md={8} lg={20} xl={20}>
                                <p className="form-field-label">
                                  {guarantor?.guarantor_type == "individual"
                                    ? "Name"
                                    : "Company Name"}
                                </p>
                                <p className="text-[12px] font-[500]">
                                  {guarantor?.personal_details?.name
                                    ? guarantor?.personal_details?.name
                                    : guarantor?.personal_details?.company_name}
                                </p>
                              </Col>
                              <Col xs={6} sm={12} md={8} lg={4} xl={4}>
                                <img
                                  className="cursor-pointer"
                                  onClick={() => {
                                    localStorage.setItem(
                                      "guarantor_details",
                                      JSON.stringify(guarantor)
                                    );
                                    window.open(
                                      "/agent/guarantor-detail"
                                    );
                                  }}
                                  src="/images/view.png"
                                />
                              </Col>
                            </Row>
                            <Row gutter={[24, 24]} className="mt-2">
                              <Col xs={24} sm={12} md={8} lg={18} xl={18}>
                                <p className="form-field-label">
                                  {guarantor?.guarantor_type == "individual"
                                    ? "NRIC (last 4 char.)"
                                    : "UEN/ACRA No (last 4 char.)"}
                                </p>
                                <p className="text-[12px] font-[500]">
                                  {guarantor?.personal_details?.uen_acra_no
                                    ? guarantor?.personal_details?.uen_acra_no
                                    : guarantor?.personal_details?.nric}
                                </p>
                              </Col>
                              <Col xs={24} sm={12} md={8} lg={6} xl={6}>
                                <p className="form-field-label">Relation</p>
                                <p className="text-[12px] font-[500]">-</p>
                              </Col>
                            </Row>
                          </div>
                        );
                      })}
                  </div>
                  <p className="text-[13px] font-[700] mt-2 mb-2">
                    Guarantor Confirmation
                  </p>
                  <div className="bg-white">
                    <div className=" p-5">
                      <div className="overflow-x-hidden">
                        <p className="text-[13px] font-[700] mb-3">
                          Furnish Guarantors:
                        </p>
                      </div>
                      <Fragment>
                        <p className="text-[13px] font-[500] mb-3">
                          Please state if any additional guarantor(s) are
                          required & what are the requirements such as relation
                          and min. income.
                        </p>
                        <p className="text-[13px] font-[500] mb-3">
                          Additional Guarantor(s)
                        </p>
                        <InputNumber
                          min={1}
                          max={3}
                          onChange={onChange}
                          className="mb-3"
                        />
                        {renderRows()}
                      </Fragment>
                    </div>
                    <div className="text-left mt-5 ml-5 pb-5">
                      <Button
                        disabled={
                          furnishGuarantorCounts == 0 || !furnishGuarantorCounts
                            ? true
                            : false
                        }
                        onClick={() => {
                          UpdateStatus("confirmstay");
                        }}
                        type="primary"
                      >
                        Confirm
                      </Button>
                    </div>
                  </div>
                  <div className="mt-5 text-right">
                    {/* changed here */}
                    {loanData?.type == "In-House" ? (           //pdf
                      <div className="text-right">
                        <Button
                          disabled={isSavePreview() ? true : false}
                          // disabled={isSavePreview() ? false : true}
                          onClick={() => {
                            UpdateStatus("save");
                          }}
                          type="primary"
                        >
                          Save & Preview AA
                        </Button>
                      </div>
                    ) : (
                      <Button
                        disabled={
                          loanData?.available_guarantors?.length > 0
                            ? selectedGuarantors.length == 0
                              ? true
                              : false
                            : false
                        }
                        onClick={() => {
                          UpdateStatus("counter");
                        }}
                        type="primary"
                      >
                        Submit
                      </Button>
                    )}
                  </div>
                </Fragment>
              )}
              {actionType == "reject" && (
                <Fragment>
                  <p className="mt-3 text-[13px] font-[400]">
                    Remarks (Optional)
                  </p>
                  <TextArea
                    onChange={(e) => {
                      setRejectReason(e.target.value);
                    }}
                    placeholder="State your remarks here"
                    className="mt-2"
                    rows={4}
                    style={{ width: "100%" }}
                  />
                  <div className="mt-5 text-right">
                    <Button
                      onClick={() => {
                        UpdateStatus("confirm");
                      }}
                      type="primary"
                    >
                      Confirm
                    </Button>
                  </div>
                </Fragment>
              )}
            </div>
          )}

          {/* changed */}
          {/* (actionType == "approve_instant_bank" &&
            loanData?.type != "In-House") || */}
          {/* viewaa */}
          {(
            (["approve_instant", "counter_instant", "approve_later", "counter_later"].includes(actionType) && loanData?.type === "In-House") ||
            (["approve_instant_bank", "counter_instant"].includes(actionType) && loanData?.type !== "In-House")
          ) && (
              <div className="bg-[#F5F5F5] p-5 mt-5 rounded flex justify-center">
                <div className="bg-white p-4  max-[768px]:w-[100%] min-[768px]:w-[70%]">
                  <div className="text-center">
                    <p className="text-15px font-[400]">
                      If you have your own AA documents, select the files to
                      upload (max 1 file)
                    </p>
                  </div>
                  <AAUpload setSelfAA={setSelfAA} />
                  <div className="text-center">
                    <Button
                      disabled={
                        loanData?.available_guarantors?.length > 0
                          ? selectedGuarantors.length == 0 || selfAA.length == 0
                            ? true
                            : false
                          : false
                      }
                      onClick={() => {
                        UpdateStatus("exit");
                      }}
                      type="primary mt-2"
                    >
                      Save
                    </Button>
                  </div>
                </div>
              </div>
            )}
        </div>
        {actionType == "approve_later" && (
          <div className="text-right mt-3">
            <Button
              disabled={
                loanData?.available_guarantors?.length > 0
                  ? selectedGuarantors.length == 0
                    ? true
                    : false
                  : false
              }
              onClick={() => {
                UpdateStatus("confirm");
              }}
              type="primary"
            >
              Confirm
            </Button>
          </div>
        )}
        <GuarantorDocumentView
          documentUrl={documentUrl}
          documentView={documentView}
          documentViewCLose={() => {
            setDocumentView(false);
          }}
        />
      </div>
    </div>
  );
};

export default ApplicationCaseStatus;
